import { modals } from "@mantine/modals";
import { Stack, Text } from "@mantine/core";
import TemplatePicker from "./TemplatePicker";

const MODAL_ID = "campaign-template-picker";

const TemplatePickerModalContent = ({ onSelect }) => {
  return (
    <Stack gap="md">
      <TemplatePicker
        showHeading={false}
        onSelect={(template) => {
          onSelect(template);
          modals.close(MODAL_ID);
        }}
      />
    </Stack>
  );
};

// Opened by the Create Campaign button. Selecting a card navigates to the new
// campaign form with ?template=<id>; dismissing the modal (X or outside click)
// cancels — the user stays on the list and no campaign form is opened.
export const openTemplatePickerModal = (onSelect) => {
  modals.open({
    modalId: MODAL_ID,
    title: "Start from a template",
    size: "lg",
    children: <TemplatePickerModalContent onSelect={onSelect} />,
  });
};
